import CONSTANTS from '../CONSTANTS';

export const actionGetKafkaList = (page = 1, limit = 20 , search=null) => ({
    type: CONSTANTS.KAFKA_GET_LIST,
    page,
    limit,
    search
});

export const actionSetKafkaList = (kafka) => ({
  type: CONSTANTS.KAFKA_SET_LIST,
  kafka,
});